module.exports = (s) => {
  return [
    {
      name: '广告平台',
      value: 'advertiser',
      align: 'center',
    },
    {
      name: '广告主',
      value: 'advertiser_id',
      align: 'center',
    },
    {
      name: '计划名称',
      value: 'name',
      overflow: false,
      width: 200,
      align: 'center',
    },
    {
      name: '广告名称',
      value: 'adgroup_name',
      overflow: false,
      width: 200,
      align: 'center',
    },
    {
      name: '广告状态',
      value: 'status',
      align: 'center',
      width: 100,
      format: (row, cell, cellValue) => {
        const obj = {
          1: '提交',
          2: '成功',
          3: '失败',
          4: '素材审核中',
          5: '队列处理中',
          6: '重试中',
        };
        return obj[cellValue];
      },
    },
    {
      name: '原因',
      value: 'reason',
      align: 'center',
      overflow: false,
      width: 600,
    },
    {
      name: '记录时间',
      value: 'created_at',
      align: 'center',
      overflow: false,
      width: 150,
    },
    {
      name: '状态更新时间',
      value: 'updated_at',
      overflow: false,
      align: 'center',
      width: 150,
    },
    {
      name: '定时提交时间',
      value: 'submit_time',
      align: 'center',
      overflow: false,
      width: 150,
    },

  ];
};
